import { useEffect } from "react";
import { motion } from "framer-motion";
import * as RadioGroup from "@radix-ui/react-radio-group";
import { useAnswer } from "../../../util/form";

export default function Glidepath({
  advanceScreen,
  previousScreen,
  updateValidation,
  screen,
  validation,
}) {
  const { answer, setAnswer } = useAnswer(screen.id);

  useEffect(() => {
    // Validate if there's already an answer
    if (answer) {
      updateValidation(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function updateAnswer(value) {
    setAnswer(value);
    updateValidation(true);
  }

  return (
    <motion.div
      className="w-full h-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.35 }}
    >
      <section className="w-full h-full px-6 py-16 text-center bg-white md:px-10 md:py-10 lg:px-16 lg:py-16">
        <div className="flex flex-col md:h-full">
          <div className="mb-10">
            <div className="max-w-xl mx-auto">
              <h1 className="text-base font-bold text-as-green-100 md:text-lg">
                Automatic asset adjustment
              </h1>
              <h2 className="mt-2 mb-4 text-3xl md:mb-5 md:mt-3 md:text-4xl">
                Would you like to be placed on an automatic Glidepath?
              </h2>
              <p>
                Artesys will protect your long-term plans from short-term risk.
                As you get closer to retirement, the Glidepath option will
                automatically move your investments to more conservative
                portfolios to help you reach your goals.
              </p>
            </div>
            <RadioGroup.Root
              className="mt-6 md:mt-10"
              aria-label="Would you like to be placed on an automatic Glidepath?"
              value={answer}
              onValueChange={updateAnswer}
            >
              <div className="flex flex-col gap-3 max-w-md mx-auto">
                <RadioGroup.Item
                  className="relative w-full rounded-lg border border-as-green-100 bg-transparent pb-4 pl-14 pr-4 pt-4 text-left before:absolute before:left-4 before:top-[1.1875rem] before:block before:h-4 before:w-4 before:rounded-full before:border before:border-as-green-100 before:bg-transparent before:content-[''] data-[state=checked]:bg-as-green-0 data-[state=checked]:before:bg-as-green-100"
                  value="true"
                  id="glidepath-yes"
                >
                  <RadioGroup.Indicator className="absolute left-[1.3125rem] top-6 h-1.5 w-1.5 rounded-full after:absolute after:inset-0 after:block after:h-1.5 after:w-1.5 after:rounded-full after:bg-white after:content-['']" />
                  <label
                    className="block text-sm font-bold leading-normal text-gray-800 cursor-pointer"
                    htmlFor="glidepath-yes"
                  >
                    Yes
                  </label>
                </RadioGroup.Item>
                <RadioGroup.Item
                  className="relative w-full rounded-lg border border-as-green-100 bg-transparent pb-4 pl-14 pr-4 pt-4 text-left before:absolute before:left-4 before:top-[1.1875rem] before:block before:h-4 before:w-4 before:rounded-full before:border before:border-as-green-100 before:bg-transparent before:content-[''] data-[state=checked]:bg-as-green-0 data-[state=checked]:before:bg-as-green-100"
                  value="false"
                  id="glidepath-no"
                >
                  <RadioGroup.Indicator className="absolute left-[1.3125rem] top-6 h-1.5 w-1.5 rounded-full after:absolute after:inset-0 after:block after:h-1.5 after:w-1.5 after:rounded-full after:bg-white after:content-['']" />
                  <label
                    className="block text-sm font-bold leading-normal text-gray-800 cursor-pointer"
                    htmlFor="glidepath-no"
                  >
                    No
                  </label>
                </RadioGroup.Item>
              </div>
            </RadioGroup.Root>
            <div className="flex justify-center gap-3 mt-6 md:mt-10 md:gap-5">
              <button className="btn btn--secondary" onClick={previousScreen}>
                Back
              </button>
              <button
                className="btn btn--primary"
                disabled={!validation}
                onClick={advanceScreen}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </section>
    </motion.div>
  );
}
